import { Children } from "react";

const Separator = ({ children }: { children: React.ReactNode }) => (
  <span>{children}</span>
);

const Separated = ({ children, separator }: { children: React.ReactNode, separator?: React.ReactNode }) => (
  Children.toArray(children).reduce((acc, child) => (
    <>
      {acc}
      {separator && <Separator>{separator}</Separator>}
      {child}
    </>
  ))
)

export const Inline = ({ children, separator }: { children: React.ReactNode, separator?: React.ReactNode }) => (
  <div style={{ display: "flex", flexDirection: "row", gap: "0.5ch", alignItems: "center" }}>
    <Separated children={children} separator={separator} />
  </div>
);